<!--
Author: Alexey Usov (dax@xdax.ru, https://github.com/doubleaxe)
Please don't remove this comment if you use unmodified file
-->
<script setup lang="ts">
import {injectBlueprintModel} from '@/scripts/model/store';
import {mdiSigma, mdiHome} from '@mdi/js';
import {injectGameData} from '@/scripts/data';

const gameData = injectGameData();
const blueprintModel = injectBlueprintModel();
const homeReference = [location.protocol, '//', location.host, location.pathname].join('')
    + `?gameId=${gameData.gameDescription.name}`;
</script>

<template>
    <tooltip-button
        class="toolbar-mobile-hidden"
        tooltip="Solve graph"
        :icon="mdiSigma"
        :disabled="blueprintModel.autoSolveGraph"
        @click="blueprintModel.solveGraph(true)"
    />
    <v-switch v-model="blueprintModel.autoSolveGraph" label="Auto" hide-details class="mr-1 toolbar-mobile-hidden" color="primary" />
    <v-divider vertical class="toolbar-mobile-hidden" />
    <a :href="homeReference" target="_blank" class="anchor-plain toolbar-mobile-hidden">
        <tooltip-button
            tooltip="Open Another Window"
            :icon="mdiHome"
        />
    </a>
    <button-load-share class="toolbar-mobile-hidden" />
    <!-- fork change (Stage H): Save / Copy Blueprint / Generate Link
         left the toolbar — Save and Copy live in the bottom-right
         action dock now, and Share there supersedes Generate Link
         (the URL itself carries the plan via the #/b/ anchor; nothing
         is uploaded to the upstream author's link server anymore) -->
    <!-- fork change (Stage I): on mobile the Load button also leaves
         the toolbar — it lives in the ⋮ menu there (see
         main-toolbar-menu.vue), so the phone toolbar is just
         Tidy layout + ⋮ next to the title -->
    <v-divider vertical class="toolbar-mobile-hidden" />
    <button-scale class="toolbar-mobile-hidden" />
    <button-tidy-layout />
    <slot name="append" />
    <main-toolbar-menu />
</template>

<style scoped>
/* fork addition (Stage I): condensed phone toolbar — solving, the
   Auto switch, another-window, Load (moved into the ⋮ menu) and
   Scale are desktop chrome; on the phone only Tidy layout and the
   ⋮ menu ride next to the (truncated) plan title */
@media (max-width: 900px) {
    .toolbar-mobile-hidden {
        display: none!important;
    }
}
</style>
